<template>
  <footer
    id="contact"
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
    style="background-color:#131C21;"
  >    
    <div class="container">
      <div class="row">
        <div class="col-md-3 col-sm-12 mb-3 text-center city">
          <img
            id="tplogo"
            src="img/transplus.png"
            height="42px"
            alt=""
            style="filter: grayscale(100%) brightness(1200%); "
          >  
         
          <br>
         
          <span style="padding:5px"> 
            <a
              href="https://www.facebook.com/TransPlus-106609531767963"
              target="_blank"
            ><i class="fab fa-facebook-square fa-2x" /></a>
          </span>
          <span>
            <a
              href="https://ca.linkedin.com/company/transplus"
              target="_blank"
            ><i class="fab fa-linkedin fa-2x" /></a>
          </span>
        </div>

        <div
          class="col-md-9 col-sm-12"
          style="padding-top:32px;"
        >
          <div class="row">
            <div class="col-md-3 gap">
              <h5 class="mb-2 font-weight-bold text-uppercase">
                MONTREAL
              </h5>
              <ul class="list-group">
                <li class="city list-group-item bg-transparent border-0 p-0 mb-2">
                  <span v-html="$t('Contact.headoffice')">Head Office</span><br>
                  2400 Halpern <br>
                  Montreal, QC, Canada <br>
                  H4S 1S8 <br>
                </li>
                <li class="phonenumber">
                  <a href="tel:5143325020"><span class="tpgreen hoverwhite"> 514 . 332 . 5020</span></a>
                </li>
              </ul>
            </div>

            <div class="col-md-3 gap">
              <h5 class="mb-2 font-weight-bold text-uppercase">
                MISSISSAUGA
              </h5>
              <ul class="list-group">
                <li class="city list-group-item bg-transparent border-0 p-0 mb-2">
                  7385 Bren Road, Unit 3 <br>
                  Mississauga, ON, Canada <br>
                  L4T 1H3 <br>
                </li>
                <li class="phonenumber">
                  <a href="tel:9053620821"><span class="tpgreen hoverwhite"> 905 . 362 . 0821</span></a>
                </li>
              </ul>
            </div>

            <div class="col-md-3 gap">
              <h5 class="mb-2 font-weight-bold text-uppercase">
                Montreal MC1
              </h5>
              <ul class="list-group">
                <li class="city list-group-item bg-transparent border-0 p-0 mb-2">
                  2450 Avenue Marie-Curie  <br>
                  Montréal, QC, Canada <br>
                  H4S 1N1 <br>         
                </li>
                <li>
                  <a
                    href="tel:5143325020"
                    class="phonenumber"
                  ><span class="tpgreen hoverwhite phonenumber"> 514 . 332 . 5020</span></a>
                </li>                    
              </ul>
            </div>

            <div class="col-md-3 gap">
              <h5 class="mb-2 font-weight-bold text-uppercase">
                Montreal MC2
              </h5>
              <ul class="list-group">
                <li class="city list-group-item bg-transparent border-0 p-0 mb-2">
                  2520 Avenue Marie-Curie  <br>
                  Montréal, QC, Canada <br>
                  H4S 1N1 <br>
                </li>
                <li>
                  <a
                    href="tel:5143325020"
                    class="phonenumber"
                  ><span class="tpgreen hoverwhite phonenumber"> 514 . 332 . 5020</span></a>
                </li>                                 
              </ul>
            </div>
          </div>
        </div>
      
        <div class="copyright col-md-12">    
          &copy; {{ year }} Transplus  Inc, All rights reserved. <br>
          <a
            target="_blank"
            href="https://docs.google.com/document/d/e/2PACX-1vSRXshaTYwWsiY7zCOSys7Qz0MvYRAIGN3X8kP2OdPR7xj1SMMeIMeTIA7Z_Sjt2w/pub"
            v-html="$t('index.privacy')"
          >Privacy Policy</a>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {    
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>
<style>
#map-canvas{
  top:-24px;
  padding-bottom: 24px; 
}

.copyright {
  text-align: center;
}
.hoverwhite {
  color: green;
}
.hoverwhite:hover{
  color: white;
}
.phonenumber{
  padding-left: -100px;
}
.gap {
  margin-bottom: 20px
}
</style>
